import { clientePedido } from '../../apiClient/index'

const moduloPedidos = {
  namespaced: true,
  state: {
    filtrosBusquedaAvanzada: []
   },
  actions: {
    
    getJerarquiaProductos(context)
    {
      return new Promise((resolve) => {
        clientePedido.get('/api/Producto/FindJerarquiaProductos')
        .then((response) => {
          let paginado = JSON.parse(response.data.Datos);
          // guardo la jerarquia de los filtros
          context.commit('setFiltrosBusquedaAvanzada', paginado.Result);
          resolve();
        });
      })
    },
    getProductos(context, payload)
    {
      return new Promise((resolve) => {
        clientePedido.post('/api/Producto/FindPorPropiedades',payload )
      .then((response) => resolve(response.data))
      })
    },
  },
  mutations:
  {
    setFiltrosBusquedaAvanzada(state, payload)
    {
      state.filtrosBusquedaAvanzada = payload;
    }
  }
 
}
export default moduloPedidos